import { Feature, isFeatureAvailable } from '@shinetools/pricing-plan-library';

import assertEventType from 'common/bento/lib/assertEventType';
import { MachineGuards } from 'common/bento/types/MachineConfig';

import { Model } from './model';

export enum Guard {
  ShouldSkipInsurance = 'shouldSkipInsurance',
  HasSelectedPackage = 'hasSelectedPackage',
  ShouldSkipPayment = 'shouldSkipPayment',
}

const guards: MachineGuards<Model, Guard> = {
  hasSelectedPackage: ({ selectedPackage }) => Boolean(selectedPackage),

  shouldSkipInsurance: (context) => {
    const hasInsuranceAssistance = isFeatureAvailable(
      context.selectedPlan,
      Feature.InsuranceAssistance,
    );
    return context.selectedPlan !== null && !hasInsuranceAssistance;
  },

  shouldSkipPayment: (context, event) => {
    assertEventType(event, 'done.invoke.getPaymentIntent');

    return Boolean(event.data.data?.getPackagePaymentIntent.readyForCapture);
  },
};

export default guards;
